export default "__VITE_ASSET__TduhNa8y__"